import * as React from "react";

export function useSingleNavMenuFixedScroll(useDetailHeader: boolean) {
  const [foundElements, setFoundElements] = React.useState(false);
  const [queryCount, setQueryCount] = React.useState(0);
  const QUERY_COUNT_LIMIT = 5;

  React.useEffect(() => {
    if (queryCount >= QUERY_COUNT_LIMIT) {
      console.error(`Cannot process "useSingleNavMenuFixedScroll", query count is depleted without finding elements`);
      return;
    }

    const pageMain = document.querySelector(`#page main`) as HTMLElement;
    if (!pageMain) {
      setQueryCount((x) => x + 1);
      return;
    }

    const nav = document.querySelector(`.singlenav-backdrop nav`) as HTMLElement;
    if (!nav) {
      setQueryCount((x) => x + 1);
      return;
    }

    setFoundElements(true);
  }, [foundElements, queryCount]);

  const HEADER_HEIGHT = 62;
  const DETAIL_HEADER_HEIGHT = 80;
  const CONTENT_PADDING = 30;

  const REDUCTION = React.useMemo(() => {
    if (useDetailHeader) {
      return HEADER_HEIGHT + CONTENT_PADDING + DETAIL_HEADER_HEIGHT;
    }
    return HEADER_HEIGHT + CONTENT_PADDING;
  }, [useDetailHeader]);

  const update = () => {
    const pageMain = document.querySelector(`#page main`) as HTMLElement;
    if (!pageMain) {
      console.error(`Cannot process "useSingleNavMenuFixedScroll" without being able to access element "#page main"`);
      return;
    }

    const el = document.querySelector(`.singlenav-backdrop nav`) as HTMLElement;
    if (!el) {
      console.error(
        `Cannot process "useSingleNavMenuFixedScroll" without being able to access element ".singlenav-backdrop nav"`,
      );
      return;
    }
    const fits = el.offsetHeight <= window.innerHeight - REDUCTION;
    const threshold = useDetailHeader ? DETAIL_HEADER_HEIGHT : 0;
    if (fits) {
      if (pageMain.scrollTop >= threshold) {
        el.style.top = `${HEADER_HEIGHT + CONTENT_PADDING}px`;
        el.style.position = "fixed";
      } else {
        el.style.top = `0`;
        el.style.position = "relative";
      }
    } else {
      el.style.top = "0";
      el.style.position = "relative";
    }
  };

  React.useEffect(() => {
    if (!foundElements) {
      return;
    }

    const pageMain = document.querySelector(`#page main`) as HTMLElement;
    if (!pageMain) {
      console.error(`Cannot process "useSingleNavMenuFixedScroll" without being able to access element "#page main"`);
      return;
    }

    pageMain.addEventListener("scroll", update);
    window.addEventListener("resize", update);

    return () => {
      pageMain.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [foundElements, useDetailHeader]);
}
